<template>
    <div class="block-box">
        <div class="block-item">
            <div class="label">
                {{configData.title}}
                <span>{{configData.list[configData.type].val}}</span>
            </div>
            <el-radio-group v-model="configData.type">
                <el-radio-button :label="index" v-for="(item, index) in configData.list" :key="index">
                    <i class="iconfont" :class="item.icon"></i>
                </el-radio-button>
            </el-radio-group>
        </div>
    </div>
</template>

<script>
    export default {
        name: "radio",
        props: {
            configData: {
                type: Object,
                default: {}
            },
        },
    }
</script>

<style scoped>

</style>
